import Home from "./pages/Home";

import "./styles/global.css";
import "./styles/colors.css";

function App() {
  return <Home />;
}

export default App;
